import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as trainingJournalService from '../services/trainingJournalService';

export const useTrainingPosts = (filters = {}) => {
  return useQuery({
    queryKey: ['training-posts', filters],
    queryFn: () => trainingJournalService.listPosts(filters),
    select: (response) => response.data,
  });
};

export const useTrainingPost = (id) => {
  return useQuery({
    queryKey: ['training-post', id],
    queryFn: () => trainingJournalService.getPost(id),
    select: (response) => response.data,
    enabled: !!id,
  });
};

export const useCreateTrainingPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => trainingJournalService.createPost(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['training-posts'] });
    },
  });
};

export const useUpdateTrainingPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => trainingJournalService.updatePost(id, data),
    onSuccess: (response) => {
      const postId = response.data?.post?._id;
      queryClient.invalidateQueries({ queryKey: ['training-posts'] });
      if (postId) {
        queryClient.invalidateQueries({ queryKey: ['training-post', postId] });
      }
    },
  });
};

export const useDeleteTrainingPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => trainingJournalService.deletePost(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['training-posts'] });
    },
  });
};
